import { matchNavItem, navigation, type NavItem, type NavModule } from '@/config/navigation'
import type { SessionStore } from '@/stores/SessionStore'

/** Whether the profile may open the page: its capabilities, and the platform-admin flag for platform pages. */
export function isPermitted(item: NavItem, session: SessionStore) {
  if (item.platformAdmin && !session.isPlatformAdmin) return false
  return session.can(item.capability) && (!item.anyCapability?.length || session.canAny(...item.anyCapability))
}

/** Planned pages are listed (disabled); ready pages only when the profile holds the capability. */
export function isVisible(item: NavItem, session: SessionStore) {
  if (item.hidden) return false
  if (item.readiness === 'planned') return true
  return isPermitted(item, session)
}

export function isOpenable(item: NavItem, session: SessionStore) {
  return item.readiness !== 'planned' && isPermitted(item, session)
}

export function visibleModules(session: SessionStore): NavModule[] {
  return navigation
    .map((module) => ({
      ...module,
      groups: module.groups
        .map((group) => ({ ...group, items: group.items.filter((item) => isVisible(item, session)) }))
        .filter((group) => group.items.length > 0),
    }))
    .filter((module) => module.groups.length > 0)
}

export function isPathAllowed(pathname: string, session: SessionStore) {
  const item = matchNavItem(pathname)
  return Boolean(item && isOpenable(item, session))
}
